export default __webpack_public_path__ + "static/media/bottom_transparency_layer.b6437530.png";